import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useFormikContext } from "formik";
import { currencyString, constants } from "@qgiv/core-js";
import { calcGiftAssistFee } from "@qgiv/core-donor";

import { selectAllFormSettings } from "../../../redux/slices/formSettingsSlice";
import {
    selectRegistrationTotals,
    updateRegistrationGiftAssist,
} from "../../../redux/slices/registrationSlice";
import GiftAssist from "./GiftAssist";

const ConnectedGiftAssist = () => {
    const dispatch = useDispatch();

    const { values, setFieldValue } = useFormikContext();
    const formSettings = useSelector(selectAllFormSettings);
    const {
        currency,
        feeCoverage,
        feeCoverageText,
        enableGiftAssistByDefault,
    } = formSettings;
    const { registrantSubtotal = 0, optionalDonationAmount = 0 } = useSelector(
        selectRegistrationTotals,
    );

    const { Gift_Assist = false } = values;
    const registrationTotal = registrantSubtotal + optionalDonationAmount;
    // Calculation of what the Gift Amount will be based on the
    // Registrant and Optional Donation totals. This total has not been applied to
    // Registration total until checked.
    const calculatedGiftAssistAmount = Number(
        calcGiftAssistFee(registrationTotal, formSettings),
    );

    const giftAssistAmountCurrencyString =
        calculatedGiftAssistAmount && calculatedGiftAssistAmount > 0
            ? `${currencyString(calculatedGiftAssistAmount, currency)}`
            : "";
    const { cms } = constants;
    const displayGiftAssist =
        Number(feeCoverage) > 0 &&
        (Number(registrationTotal) > 0 || cms === "1");
    // Returns the markup for the gift assist label based on whether or not
    // the calculatedGiftAssistAmount is > 0 and gift assist is checked
    const renderGiftAssistLabel = () => {
        const feeDisplay = `(<span class="gift-assist__amount">${giftAssistAmountCurrencyString}</span>)`;

        const regex = /%Fee%/gi;
        const newLabel = feeCoverageText.replace(regex, feeDisplay);
        const createLabel = () => ({ __html: newLabel });
        return (
            <span
                className="-padding-right--10"
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={createLabel()}
            />
        );
    };

    useEffect(() => {
        // I hate to add another useEffect but setting it as an initial value is not an option
        // since there is a useEffect in OptionalDonations that clears the gift assist value if
        // there is no optional donation.  This form never starts with an optional donation so the
        // default as would always be overwritten. We also need this to be set only if the component
        // is visible.
        if (displayGiftAssist && enableGiftAssistByDefault) {
            setFieldValue("Gift_Assist", !!enableGiftAssistByDefault);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [displayGiftAssist, enableGiftAssistByDefault]);

    const giftAssistProps = {
        Gift_Assist,
        displayGiftAssist,
        renderGiftAssistLabel,
        updateRegistrationGiftAssist,
        dispatch,
    };

    return <GiftAssist {...giftAssistProps} />;
};

export default ConnectedGiftAssist;
